export const CPhotoCollageFragments = {
  field: `
    fragment photoCollage on photoCollage_MatrixField {
      ... on photoCollage_block_Entry {
        id
        typeHandle
        idName
        images {
          url
          title
        }
      }
    }
  `,
}
